module.exports = __webpack_public_path__ + "img/grey-intensives-2.7c254bdb.png";